import React from 'react';
import { featureBookingModalConfig } from '@/shared/config/tests/e2e/features/booking';
import { Button } from '@/shared/ui/button';
import { DialogHeader, DialogTitle } from '@/shared/ui/dialog';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
interface Props {
  doctorName: string;
  hideModal: () => void;
}
export const BookingModalTitle: React.FC<Props> = ({
  doctorName,
  hideModal
}) => {
  return <DialogHeader data-sentry-element="DialogHeader" data-sentry-component="BookingModalTitle" data-sentry-source-file="BookingModalTitle.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="BookingModalTitle.tsx">
        <span className="text-xl font-bold md:text-2xl" data-testid={featureBookingModalConfig.ids.bookingModalTitle}>
          {doctorName}
        </span>

        <Button variant="circle" className="size-12 min-w-12 bg-bgSecondary" onClick={hideModal} data-testid={featureBookingModalConfig.ids.closeModalButton} data-sentry-element="Button" data-sentry-source-file="BookingModalTitle.tsx">
          <svg className="size-6 rotate-180 stroke-textPrimary" data-sentry-element="svg" data-sentry-source-file="BookingModalTitle.tsx">
            <use xlinkHref={`${btnIcons}#close`} data-sentry-element="use" data-sentry-source-file="BookingModalTitle.tsx"></use>
          </svg>
        </Button>
      </DialogTitle>
    </DialogHeader>;
};